// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vue-dropzone>.dz-preview .dz-error-message{top:0}#dropzone{align-items:center;border:2px dashed gray;border-radius:20px;display:flex;justify-content:center;width:100%}.dropzone .dz-preview .dz-image{z-index:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
